import { useState, useEffect, useContext } from "react";
import Context from "../../scripts/context/User";
import { WalletContext } from "../../scripts/context/WalletContext";
import {
  Avatar,
  IconButton,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import Jazzicon, { jsNumberForAddress } from "react-jazzicon";
import LogoutIcon from "@mui/icons-material/Logout";

import CustomLink from "../Link";
import Brand from "../../assets/BrandText";
import DropMenu from "./DropMenu";

import { SHORTEN_ADDRESS } from "../RegisterSteps/LinkWallet/constants";

import { MenuStyle } from "./style";
import { initWeb3State } from "../../scripts/constants";

export default function Navbar({ isDark, handleToggleThemes }) {
  const { globalState } = useContext(Context);
  const { connectWallet, web3, loading, setWeb3 } = useContext(WalletContext);
  const { account, contracts } = web3;

  const [anchorElUser, setAnchorElUser] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [openMenuUser, setOpenMenuUser] = useState(false);
  const [openAddressSettings, setOpenAddressSettings] = useState(false);

  const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);
  const disconnectWallet = async () => {
    if (web3.account.walletConnectProvider?.connected) {
      await web3.account.walletConnectProvider.disconnect();
      setWeb3(initWeb3State);
      setOpenAddressSettings(null);
    } else {
      setWeb3(initWeb3State);
      setOpenAddressSettings(null);
    }
  };

  useEffect(() => {
    if (openMenuUser) {
      document.body.classList.add("topbar-mobile-on");
    } else {
      document.body.classList.remove("topbar-mobile-on");
    }
  }, [openMenuUser]);

  return (
    <>
      <div
        id="kt_header_mobile"
        className={`header-mobile${isDark ? " dark-mode" : ""}`}
      >
        <a href="/">
          <Brand
            className="logo-default h-30px max-h-30px"
            color={isDark ? "#fff" : "#002c74"}
          />
        </a>
        <div className="d-flex align-items-center">
          <button
            className="btn p-0 burger-icon burger-icon-left ml-4"
            id="kt_header_mobile_toggle"
            onClick={() => setOpenMenu(true)}
            type="button"
          >
            <span></span>
          </button>

          <button
            className="btn btn-icon btn-hover-transparent-dark p-0 ml-3"
            id="kt_header_mobile_topbar_toggle"
            onClick={() => setOpenMenuUser(!openMenuUser)}
          >
            <span className="svg-icon svg-icon-xl">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <polygon points="0 0 24 0 24 24 0 24" />
                  <path
                    d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z"
                    fill="#000000"
                    fill-rule="nonzero"
                    opacity="0.3"
                  />
                  <path
                    d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z"
                    fill="#000000"
                    fill-rule="nonzero"
                  />
                </g>
              </svg>
            </span>
          </button>
        </div>
      </div>
      <div
        id="kt_header"
        className={`header header-fixed${isDark ? " dark-mode" : ""}`}
      >
        <div className="container-fluid d-flex align-items-stretch justify-content-between">
          <div className="d-flex align-items-stretch center-header">
            <div className="header-logo">
              <CustomLink to={globalState.redirect_uri}>
                <Brand
                  className="logo-default h-40px max-h-40px"
                  color={isDark ? "#fff" : "#002c74"}
                />
              </CustomLink>
            </div>
            {globalState.user?.status === "Active" && (
              <div
                className={`header-menu-wrapper header-menu-wrapper-left${
                  openMenu ? " header-menu-wrapper-on" : ""
                }`}
                id="kt_header_menu_wrapper"
              >
                <div
                  id="kt_header_menu"
                  className="header-menu header-menu-left header-menu-mobile  header-menu-layout-default "
                >
                  <ul className="menu-nav">
                    {globalState.user.invitation_code && (
                      <li
                        className="menu-item"
                        onClick={() => setOpenMenu(false)}
                      >
                        <CustomLink
                          to="/wallet/commission"
                          className="menu-link menu-toggle"
                          activeClassName="active-item"
                        >
                          <span className="menu-text">Commission</span>
                        </CustomLink>
                      </li>
                    )}
                    <li
                      className="menu-item"
                      onClick={() => setOpenMenu(false)}
                    >
                      <CustomLink
                        to="/wallet/balance"
                        className="menu-link menu-toggle"
                        activeClassName="active-item"
                      >
                        <span className="menu-text">Balance</span>
                      </CustomLink>
                    </li>
                    {/* <li
                      className="menu-item"
                      onClick={() => setOpenMenu(false)}
                    >
                      <CustomLink
                        to="/wallet/stake"
                        className="menu-link menu-toggle"
                        activeClassName="active-item"
                      >
                        <span className="menu-text">LP Stake</span>
                      </CustomLink>
                    </li> */}
                  </ul>
                </div>
              </div>
            )}

            {openMenu && (
              <div
                onClick={() => setOpenMenu(false)}
                className="header-menu-wrapper-overlay"
              ></div>
            )}
            <div className="topbar">
              {loading ? (
                <div
                  className="d-flex align-items-center gap-1"
                  style={{ height: "25px", alignSelf: "center" }}
                >
                  <span className="loading-row w-200px full-height" />
                  <span className="loading-row w-50px full-height" />
                </div>
              ) : account.address && contracts.presale.contract ? (
                <div className="addres-info">
                  <span>{account.balance} TFUEL</span>
                  <button
                    onClick={(event) =>
                      setOpenAddressSettings(event.currentTarget)
                    }
                  >
                    <span>{SHORTEN_ADDRESS(account.address)}</span>
                    <Jazzicon
                      diameter={20}
                      seed={jsNumberForAddress(account.address)}
                    />
                  </button>
                  <MenuStyle
                    sx={{
                      mt: "45px",
                      ".MuiButtonBase-root:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.15)",
                      },
                    }}
                    id="menu-appbar"
                    anchorEl={openAddressSettings}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={Boolean(openAddressSettings)}
                    onClose={() => setOpenAddressSettings(null)}
                  >
                    <MenuItem className="profile" onClick={disconnectWallet}>
                      <Typography textAlign="center">
                        <LogoutIcon />
                        Disconnect Wallet
                      </Typography>
                    </MenuItem>
                  </MenuStyle>
                </div>
              ) : (
                globalState.user?.status === "Active" && (
                  <div className="sc-17c8lce-2 bodOQc ml-3 mr-3">
                    <div className="sc-17c8lce-4 fTIUty">
                      <button
                        onClick={connectWallet}
                        id="connect-wallet"
                        className="sc-bdnxRM bhVlig sc-tdn257-0 sc-tdn257-4 sc-wwio5h-1 sc-wwio5h-3 gbdlPl cVOjRk idVMnL bmxxax"
                        type="button"
                      >
                        <p className="sc-wwio5h-5 bhIQsL">
                          Connect to a Wallet
                        </p>
                      </button>
                    </div>
                  </div>
                )
              )}

              <div className="dropdown">
                <div
                  className="topbar-item"
                  data-toggle="dropdown"
                  data-offset="10px,0px"
                >
                  <div
                    className="btn-theme-changer d-flex align-items-center"
                    style={{ borderRadius: "1rem" }}
                    onClick={handleToggleThemes}
                  >
                    <span className="svg-icon svg-icon-xl d-flex mr-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        version="1.1"
                      >
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <rect x="0" y="0" width="24" height="24" />
                          <path
                            d="M12,15 C10.3431458,15 9,13.6568542 9,12 C9,10.3431458 10.3431458,9 12,9 C13.6568542,9 15,10.3431458 15,12 C15,13.6568542 13.6568542,15 12,15 Z"
                            fill="#000000"
                            fill-rule="nonzero"
                          />
                          <path
                            d="M19.5,10.5 L21,10.5 C21.8284271,10.5 22.5,11.1715729 22.5,12 C22.5,12.8284271 21.8284271,13.5 21,13.5 L19.5,13.5 C18.6715729,13.5 18,12.8284271 18,12 C18,11.1715729 18.6715729,10.5 19.5,10.5 Z M16.0606602,5.87132034 L17.1213203,4.81066017 C17.7071068,4.22487373 18.6568542,4.22487373 19.2426407,4.81066017 C19.8284271,5.39644661 19.8284271,6.34619408 19.2426407,6.93198052 L18.1819805,7.99264069 C17.5961941,8.57842712 16.6464466,8.57842712 16.0606602,7.99264069 C15.4748737,7.40685425 15.4748737,6.45710678 16.0606602,5.87132034 Z M16.0606602,18.1819805 C15.4748737,17.5961941 15.4748737,16.6464466 16.0606602,16.0606602 C16.6464466,15.4748737 17.5961941,15.4748737 18.1819805,16.0606602 L19.2426407,17.1213203 C19.8284271,17.7071068 19.8284271,18.6568542 19.2426407,19.2426407 C18.6568542,19.8284271 17.7071068,19.8284271 17.1213203,19.2426407 L16.0606602,18.1819805 Z M3,10.5 L4.5,10.5 C5.32842712,10.5 6,11.1715729 6,12 C6,12.8284271 5.32842712,13.5 4.5,13.5 L3,13.5 C2.17157288,13.5 1.5,12.8284271 1.5,12 C1.5,11.1715729 2.17157288,10.5 3,10.5 Z M12,1.5 C12.8284271,1.5 13.5,2.17157288 13.5,3 L13.5,4.5 C13.5,5.32842712 12.8284271,6 12,6 C11.1715729,6 10.5,5.32842712 10.5,4.5 L10.5,3 C10.5,2.17157288 11.1715729,1.5 12,1.5 Z M12,18 C12.8284271,18 13.5,18.6715729 13.5,19.5 L13.5,21 C13.5,21.8284271 12.8284271,22.5 12,22.5 C11.1715729,22.5 10.5,21.8284271 10.5,21 L10.5,19.5 C10.5,18.6715729 11.1715729,18 12,18 Z M4.81066017,4.81066017 C5.39644661,4.22487373 6.34619408,4.22487373 6.93198052,4.81066017 L7.99264069,5.87132034 C8.57842712,6.45710678 8.57842712,7.40685425 7.99264069,7.99264069 C7.40685425,8.57842712 6.45710678,8.57842712 5.87132034,7.99264069 L4.81066017,6.93198052 C4.22487373,6.34619408 4.22487373,5.39644661 4.81066017,4.81066017 Z M4.81066017,19.2426407 C4.22487373,18.6568542 4.22487373,17.7071068 4.81066017,17.1213203 L5.87132034,16.0606602 C6.45710678,15.4748737 7.40685425,15.4748737 7.99264069,16.0606602 C8.57842712,16.6464466 8.57842712,17.5961941 7.99264069,18.1819805 L6.93198052,19.2426407 C6.34619408,19.8284271 5.39644661,19.8284271 4.81066017,19.2426407 Z"
                            fill="#000000"
                            fill-rule="nonzero"
                            opacity="0.7"
                          />
                        </g>
                      </svg>
                      <span className="slash-between">/</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        version="1.1"
                      >
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <rect x="0" y="0" width="24" height="24" />
                          <path
                            d="M12.0700837,4.0003006 C11.3895108,5.17692613 11,6.54297551 11,8 C11,12.3948932 14.5439081,15.9620623 18.9299163,15.9996994 C17.5467214,18.3910707 14.9612535,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 C12.0233848,4 12.0467462,4.00010034 12.0700837,4.0003006 Z"
                            fill="#000000"
                          />
                        </g>
                      </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div className="dropdown">
                <div className="topbar-iftem">
                  <div
                    className="btn btn-icon d-flex align-items-center btn-lg px-md-2 w-md-auto"
                    id="kt_quick_user_toggle"
                  >
                    <Tooltip onClick={handleOpenUserMenu} title="Open settings">
                      <IconButton sx={{ p: 0 }}>
                        <Avatar
                          alt={globalState.user?.full_name || "User"}
                          src={globalState.user?.avatar || ""}
                        />
                      </IconButton>
                    </Tooltip>
                    <DropMenu
                      anchorElUser={anchorElUser}
                      setAnchorElUser={setAnchorElUser}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
